import styled from 'styled-components';

export const ProgressWheel = styled.div<{ percent: number }>`
  position: relative;
  width: 16px;
  height: 16px;

  &::before {
    content: '';
    position: absolute;
    border-radius: 50%;
    inset: 0;
    background: conic-gradient(
      ${(p): string => p.theme.colors?.colorGray2 || ''} calc(${(p): number => p.percent} * 1%),
      #0000 0
    );
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border: 1px solid ${(p): string => p.theme.colors?.colorGray2 || ''};
    border-radius: 50%;
  }
`;
